import { render, staticRenderFns } from "./CompareHeadlineCanvasBlobless.vue?vue&type=template&id=1cde2e99&scoped=true&"
import script from "./CompareHeadlineCanvasBlobless.vue?vue&type=script&lang=js&"
export * from "./CompareHeadlineCanvasBlobless.vue?vue&type=script&lang=js&"
import style0 from "./CompareHeadlineCanvasBlobless.vue?vue&type=style&index=0&id=1cde2e99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cde2e99",
  null
  
)

export default component.exports